import { ReceiptItemDto } from "./ReceiptItemDto";

export interface ReceiptDto {
  receiptNumber: string;
  externalReceiptId: string;
  status: string;
  thumbnailUrl: string;
  imageUrl: string;
  reviewedBy?: string;
  customerNumber: string;
  rejectedAt?: string;
  totalAmount?: string;
  submissionDate: string;
  receiptDate: string;
  unitNumber: string;
  bonusPoints: string;
  items: ReceiptItemDto[];
}

export enum ReceiptStatus {
  UPLOADING = "UPLOADING",
  UPLOADED = "UPLOADED",
  REQUESTING_CREATE_INTERACTION = "REQUESTING_CREATE_INTERACTION",
  COMPLETED = "COMPLETED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  FAILED = "FAILED",
}
